import DOMPurify from 'dompurify';
import Form from '@rjsf/core';
import _, { throttle, isArray, isEmpty } from 'lodash';
import { retrieveSchema, toPathSchema } from '@rjsf/core/lib/utils.js';

//util
import { differenceInObjects } from '../../Shared/FormHelpers/helpers/utils.js';
import * as Constants from './Shared/SurveyFormConstants.js';
import React from 'react';
import { cleanTransactions, validateTransactions } from './utils.js';

class EASForm extends Form {
  constructor(props) {
    super(props);
    const superOnChange = this.onChange;

    this.state = {
      ...this.state,
      autosaveQueue: [],
    };

    this.throttledOnChange = throttle(this.throttledOnChange.bind(this), 3000, {
      leading: false,
      trailing: true,
    });

    this.onChange = formData => {
      if (this.props.readOnly) {
        return;
      }

      this.updateFormData('onChange', formData);
      superOnChange(formData);
    };
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  }

  // Remove the event listener in componentWillUnmount to avoid memory leaks
  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  // Function to handle the beforeunload event
  handleBeforeUnload = event => {
    const { formData, autosaveTriggered } = this.state;
    const { originalData } = this.props;

    // Check if there are any pending changes
    if (autosaveTriggered) {
      event.preventDefault();
      event.returnValue = ''; // Chrome requires this to be set for the dialog to show

      // Trigger the throttled autosave function manually

      return 'You have unsaved changes. Are you sure you want to leave the page?';
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const diff = differenceInObjects(
      this.props.originalData,
      prevProps.originalData
    );
    if (!_.isEmpty(this.props.originalData) && !_.isEmpty(diff)) {
      this.setState({ ...this.state, originalData: this.props.originalData });
    }
  }

  ShouldUpdateOnBlur = id => {
    var element = document.getElementById(id);

    if (!element) return false;

    let elementTagType = element.tagName.toLowerCase();
    if (elementTagType === 'input' && element.getAttribute('type') === 'text')
      return true;

    if (elementTagType === 'textarea' || elementTagType === 'trix-editor')
      return true;

    return false;
  };

  skipAutoSaveForFiles = id => {
    var element = document.getElementById(id);

    if (!element) return false;
    // Check if the element has 'evidence-files' class
    if (element.classList.contains('evidence-files')) return true;

    return false;
  };

  cleanUpDefaultValues = obj => {
    // Step 1: Check if object has more than one property
    if (Object.keys(obj).length > 1) {
      // Step 2: Get the first key
      const firstKey = Object.keys(obj)[0];
      // Step 3: Check if that entry has 'yes_date'
      if (obj[firstKey].hasOwnProperty('yes_date')) {
        // Step 4: Remove the object
        delete obj[firstKey];
      }
    }
  };

  BuildId = (id, structure, diveInArray = false) => {
    for (var item in structure) {
      if (structure.hasOwnProperty(item)) {
        var nextId = id + '_' + item;
        var nextStructure = structure[item];
        if (
          typeof nextStructure == 'object' &&
          !Array.isArray(nextStructure) &&
          nextStructure != null
        ) {
          return this.BuildId(nextId, nextStructure, diveInArray);
        } else if (Array.isArray(nextStructure) && !diveInArray) {
          let itemIndex = structure[item].length - 1;
          let itemStructure = structure[item][itemIndex];
          for (var input in itemStructure) {
            return id + '_' + item + '_' + itemIndex + '_' + input;
          }
        } else {
          for (var input in structure) {
            return id + '_' + input;
          }
        }
      }
    }
    return nextId;
  };

  omitNACheckboxes = (oldData, newData) => {
    // Iterate over each question in newData
    for (const guid in newData) {
      if (newData.hasOwnProperty(guid)) {
        // Check if na_checkbox exists in newData and not in oldData
        if (
          newData[guid].hasOwnProperty('na_checkbox') &&
          !(
            oldData &&
            oldData[guid] &&
            oldData[guid].hasOwnProperty('na_checkbox')
          )
        ) {
          // If na_checkbox is false in newData, remove it
          if (newData[guid].na_checkbox === false) {
            delete newData[guid].na_checkbox;
          }
        }
        // remove question if it doesn't have any children
        if (Object.keys(newData[guid]).length === 0) {
          delete newData[guid];
        }
      }
    }
    return newData;
  };

  differenceInObjects = (object, base) => {
    function changes(object, base) {
      return _.transform(object, function(result, value, key) {
        if (!_.isEqual(value, base[key])) {
          if (_.isObject(value) && _.isObject(base[key])) {
            result[key] = changes(value, base[key]);
          } else {
            result[key] = value;
          }
        }
      });
    }
    return changes(object, base);
  };

  getChangedSection(id, base, structure) {
    var restults = {},
      nextBase,
      item,
      nextStructure,
      nextId;
    for (item in structure) {
      if (base.hasOwnProperty(item)) {
        nextId = id + '_' + item;
        nextBase = base[item];
        nextStructure = structure[item];
        if (
          typeof nextBase == 'object' &&
          !Array.isArray(nextBase) &&
          nextBase != null
        ) {
          restults[item] = this.getChangedSection(
            nextId,
            nextBase,
            nextStructure
          );
        } else {
          var inputsList = {};
          // check if inputs exist
          for (var input in base) {
            var element = document.getElementById(id + '_' + input);
            if (
              (typeof element != 'undefined' && element != null) ||
              input == 'CitationPicker' ||
              input == 'CAPA' ||
              input == 'findings'
            ) {
              inputsList[input] = base[input];
            }
          }
          return inputsList;
        }
      }
    }
    return restults;
  }

  trimObj = e => {
    let copyObj = { ...e };
    Object.keys(e).forEach(i => {
      if (
        i === 'Citation' ||
        i === 'amsFormId' ||
        i === 'performanceArea' ||
        i === 'evidence_source' ||
        i === 'contentArea' ||
        i === 'citations' ||
        i === 'editedTime' ||
        i === 'isValidated' ||
        i === 'questionId' ||
        i === 'editedBy' ||
        (copyObj[i] && copyObj[i].length === 0)
      ) {
        delete copyObj[i];
        delete e[i];
      }
    });

    return _.isEmpty(copyObj);
  };

  throttledOnChange(parentSection, validated, invalidQuestiosns, formData) {
    for (const questionId of this.state.autosaveQueue) {
      this.props.onAutoSave(
        questionId.parentSection,
        questionId.validated,
        questionId.invalidQuestiosns,
        formData
      );
    }
    //this.props.onAutoSave(parentSection, validated, formData);
    this.setState({
      ...this.state,
      originalData: formData,
      autosaveTriggered: false,
      autosaveQueue: [],
    });
  }

  omitExtraData(formData, formSchema) {
    const retrievedSchema = retrieveSchema(
      formSchema ?? this.state.schema,
      formSchema ?? this.state.schema,
      formData
    );
    const pathSchema = toPathSchema(
      retrievedSchema,
      '',
      formSchema ?? this.state.schema,
      formData
    );
    this.ignoreNoCheckboxList(retrievedSchema, formData);
    const fieldNames = this.getFieldNames(pathSchema, formData);
    return this.getUsedFormData(formData, fieldNames);
  }

  ignoreNoCheckboxList = (retrievedSchema, formData) => {
    const props = retrievedSchema.properties;
    for (const keyProp in props) {
      if (props.hasOwnProperty(keyProp)) {
        const innerProps = props[keyProp].properties;
        if (innerProps?.fiscal_year?.value > 2024) {
          if (
            innerProps.hasOwnProperty('no_checkbox_list') &&
            innerProps.no_checkbox_list.readOnly
          ) {
            Object.keys(formData).forEach(key => {
              if (
                key === keyProp &&
                formData[key].hasOwnProperty('no_checkbox_list') &&
                'No' !== formData.tq_answer
              ) {
                delete formData[key].no_checkbox_list;
              }
            });
          }
        }
      }
    }
  };

  omitOtherValues = (retrievedSchema, formData) => {
    if (!formData) return;
    if (!retrievedSchema) return;

    const props = retrievedSchema.properties;
    for (const key in props) {
      if (formData.hasOwnProperty(key)) {
        var checklist = formData[key]?.no_checkbox_list;
        if (!checklist) checklist = formData[key]?.yes_checkbox_list;
        if (!checklist) checklist = formData[key]?.checkboxlist;
        if (checklist) {
          const index = checklist.findIndex(el =>
            el?.toString().startsWith(Constants.OTHER_REASON_KEY)
          );

          if (index !== -1) {
            const otherReason = checklist[index];
            const textOnly = otherReason.replace(
              Constants.OTHER_REASON_KEY,
              ''
            );

            if (!this.hasMeaningfulText(textOnly)) {
              checklist.splice(index, 1); // remove the invalid "Other Reason"
            }
          }
        }
      }
    }
  };

  async updateFormData(eventName, formData) {
    let modifiedFormData = _.omitBy(formData, this.trimObj);
    let modifiedData = _.omitBy(this.state.originalData, this.trimObj);
    modifiedFormData = this.omitNACheckboxes(modifiedData, modifiedFormData);

    if (this.props.onChangeCallback) this.props.onChangeCallback(formData);
    var changedStructure = this.differenceInObjects(
      modifiedFormData,
      modifiedData
    );
    //check if wsywig issue
    const changedKeys = Object.keys(changedStructure);
    if (changedKeys.length === 1) {
      const question = changedStructure[changedKeys[0]];
      let originalNotes =
        modifiedData &&
        modifiedData[changedKeys[0]] &&
        modifiedData[changedKeys[0]].notes
          ? modifiedData[changedKeys[0]].notes
          : '';
      let cleanedQuestionNotes =
        question.notes &&
        question.notes.length > 0 &&
        question.notes.replace('<div>', '').replace('</div>', '');
      if (question.findings) {
        let findingIndex = question.findings.length - 1;
        if (
          question.findings[findingIndex] &&
          question.findings[findingIndex].notes
        ) {
          originalNotes =
            modifiedData &&
            modifiedData[changedKeys[0]] &&
            modifiedData[changedKeys[0]].findings &&
            modifiedData[changedKeys[0]].findings[findingIndex] &&
            modifiedData[changedKeys[0]].findings[findingIndex].notes
              ? modifiedData[changedKeys[0]].findings[findingIndex].notes
              : '';
          let changedNotes =
            question.findings[findingIndex].notes.length > 0 &&
            question.findings[findingIndex].notes;
          cleanedQuestionNotes =
            changedNotes &&
            changedNotes.replace('<div>', '').replace('</div>', '');
        }
        if (
          question.findings[findingIndex] &&
          question.findings[findingIndex].reason
        ) {
          originalNotes =
            modifiedData &&
            modifiedData[changedKeys[0]] &&
            modifiedData[changedKeys[0]].findings &&
            modifiedData[changedKeys[0]].findings[findingIndex] &&
            modifiedData[changedKeys[0]].findings[findingIndex].reason
              ? modifiedData[changedKeys[0]].findings[findingIndex].reason
              : '';
          let changedNotes =
            question.findings[findingIndex].reason.length > 0 &&
            question.findings[findingIndex].reason;
          cleanedQuestionNotes =
            changedNotes &&
            changedNotes.replace('<div>', '').replace('</div>', '');
        }
      }

      // Compare cleanedQuestionNotes with modifiedNotes
      if (cleanedQuestionNotes === originalNotes) return;

      // Skip auto save if the last change was removing the last
      // evidence file in a quesiton
      var questionsData = formData[changedKeys[0]];
      if (!questionsData.evidence && modifiedData[changedKeys[0]]?.evidence) {
        return;
      }
    }

    if (this.props.readOnly || this.props.containsOriginalResponse)
      if (this.props.readOnly || this.props.containsOriginalResponse) return;

    if (
      !_.isEmpty(changedStructure) &&
      _.isEmpty(changedStructure[Object.keys(changedStructure)[0]])
    ) {
      changedStructure = {
        [Object.keys(changedStructure)[0]]:
          modifiedFormData[Object.keys(changedStructure)[0]],
      };
    }

    if (_.isEmpty(changedStructure)) {
      var changedStructure = this.differenceInObjects(
        modifiedData,
        modifiedFormData
      );
    }

    this.cleanUpDefaultValues(changedStructure);
    var id = this.BuildId('root', changedStructure, false);
    var parentId = this.BuildId('root', changedStructure, true);

    var parentSection = this.getChangedSection(
      'root',
      formData,
      changedStructure
    );

    const validated = this.validateQuestion(
      Object.keys(parentSection)[0],
      formData
    );
    let invalidQuestiosnsIds = [];
    if (this.props.isMultiForm) {
      for (var key in Object.keys(this.state.schema.properties)) {
        var questionId = Object.keys(this.state.schema.properties)[key];
        if (!this.validateQuestion(questionId, formData)) {
          invalidQuestiosnsIds.push(questionId);
        }
      }
    }
    let invalidQuestiosns = {
      title: this.props.title,
      ids: invalidQuestiosnsIds,
    };

    //if text area, then throttle autosave changes and check for other reason box
    let otherReasonChanged = false;
    var changedStructureKeys = Object.keys(changedStructure);
    if (changedStructureKeys.length > 0) {
      var key = changedStructureKeys[0];
      var modifiedDataNoCheckboxList = _.get(
        modifiedData,
        `${key}.no_checkbox_list`
      );
      var modifiedFormDataNoCheckboxList = _.get(
        modifiedFormData,
        `${key}.no_checkbox_list`
      );

      var modifiedDataCheckboxList = _.get(modifiedData, `${key}.checklist`);
      var modifiedFormDataCheckboxList = _.get(
        modifiedFormData,
        `${key}.checklist`
      );

      var modifiedDataCheckboxList_Other = _.get(
        modifiedData,
        `${key}.checklist_other`
      );
      var modifiedFormDataCheckboxList_Other = _.get(
        modifiedFormData,
        `${key}.checklist_other`
      );

      var modifiedFormDataValue =
        modifiedFormDataNoCheckboxList &&
        modifiedFormDataNoCheckboxList.find(value =>
          value.startsWith('opt-other-reason')
        );

      var modifiedDataValue =
        modifiedDataNoCheckboxList &&
        modifiedDataNoCheckboxList.find(value =>
          value.startsWith('opt-other-reason')
        );

      if (
        modifiedFormDataCheckboxList &&
        Array.isArray(modifiedFormDataCheckboxList)
      ) {
        modifiedFormDataValue =
          modifiedFormDataCheckboxList &&
          modifiedFormDataCheckboxList.find(value =>
            value.startsWith('opt-other-reason')
          );
      }

      if (modifiedDataCheckboxList && Array.isArray(modifiedDataCheckboxList)) {
        modifiedDataValue =
          modifiedDataCheckboxList &&
          modifiedDataCheckboxList.find(value =>
            value.startsWith('opt-other-reason')
          );
      }

      if (modifiedFormDataCheckboxList_Other) {
        modifiedFormDataValue = modifiedFormDataCheckboxList_Other;
      }

      if (modifiedDataCheckboxList_Other) {
        modifiedDataValue = modifiedDataCheckboxList_Other;
      }

      otherReasonChanged =
        (modifiedFormDataValue && !modifiedDataValue) ||
        (modifiedDataValue && !modifiedFormDataValue) ||
        (modifiedFormDataValue &&
          modifiedDataValue &&
          modifiedFormDataValue !== modifiedDataValue);
    }

    if (
      eventName === 'onChange' &&
      !this.hasCheckListBeenCleared(
        modifiedData,
        modifiedFormData,
        changedStructureKeys
      ) &&
      this.skipAutoSaveForFiles(parentId)
    ) {
      return;
    }
    if (eventName === 'onChange' && this.skipAutoSaveForFiles(id)) {
      return;
    }

    // clean up evidence files and remove autosave from the data
    if (
      formData &&
      Object.keys(changedStructure) &&
      Object.keys(changedStructure).length > 0
    ) {
      const key = Object.keys(changedStructure)[0];
      if (formData[key]) this.removeAutoSaveFromEvidence(formData[key]);
    }

    if (
      (eventName === 'onChange' && this.ShouldUpdateOnBlur(id)) ||
      otherReasonChanged
    ) {
      if (
        otherReasonChanged &&
        modifiedFormDataValue === undefined &&
        modifiedDataValue.length > 0
      ) {
      } else {
        const { autosaveQueue } = this.state;

        // Find index of the item with the same key
        const index = autosaveQueue.findIndex(item => item.key === key);

        // If found, replace that item with the new data; otherwise add the new item
        let updatedQueue;
        if (index !== -1) {
          updatedQueue = [...autosaveQueue];
          updatedQueue[index] = {
            key,
            parentSection,
            validated,
            invalidQuestiosns,
          };
        } else {
          updatedQueue = [
            ...autosaveQueue,
            { key, parentSection, validated, invalidQuestiosns },
          ];
        }

        this.setState({
          ...this.state,
          autosaveTriggered: true,
          autosaveQueue: updatedQueue,
        });

        await this.throttledOnChange(
          parentSection,
          validated,
          invalidQuestiosns,
          formData
        );
        return;
      }
    }

    if (this.state.autosaveQueue.some(item => item.key === key)) {
      const updatedAutosaveQueue = this.state.autosaveQueue.filter(
        item => item.key !== key
      );
      this.setState({
        ...this.state,
        autosaveQueue: updatedAutosaveQueue,
        originalData: formData,
      });
    } else {
      this.setState({ ...this.state, originalData: formData });
    }
    await this.props.onAutoSave(
      parentSection,
      validated,
      invalidQuestiosns,
      formData
    );
  }

  adjustFormData = (formSchema, formData) => {
    if (
      formSchema &&
      formSchema.na_checkbox &&
      formData &&
      !formData.na_checkbox
    )
      formData.na_checkbox = false;
  };

  hasCheckListBeenCleared = (prevData, mewData, changedStructureKeys) => {
    if (changedStructureKeys && changedStructureKeys.length == 0) return false;
    var key = changedStructureKeys[0];
    if (!prevData || !prevData[key]) return false;
    return (
      (prevData[key].no_checkbox_list &&
        mewData[key].no_checkbox_list === undefined) ||
      (prevData[key].yes_checkbox_list &&
        mewData[key].yes_checkbox_list === undefined) ||
      (prevData[key].checklist && mewData[key].checklist === undefined)
    );
  };

  validateQuestion = (field, formData, formSchema) => {
    const retrievedSchema = retrieveSchema(
      formSchema ?? this.state.schema,
      formSchema ?? this.state.schema,
      formData
    );

    const selectedQuestionFormSchema =
      retrievedSchema &&
      retrievedSchema.properties[field] &&
      retrievedSchema.properties[field].properties;

    this.adjustFormData(selectedQuestionFormSchema, formData[field]);

    const errorObj = this.validate(formData, formSchema);
    const { errorSchema } = errorObj;
    const questionData = this.omitExtraData(formData, formSchema);
    const cleanQuestionData = questionData[field];

    if (
      this.props.formContext?.attributes?.evidenceSource ===
        'Findings Outside the Protocol' &&
      cleanQuestionData?.tq_answer === 'Yes'
    ) {
      return this.validateFindingsObj(formData, field);
    }

    var obj = errorSchema[field];
    if (
      this.props.formContext?.attributes?.evidenceSource ==
        'Findings Outside the Protocol' &&
      cleanQuestionData &&
      cleanQuestionData.tq_answer &&
      cleanQuestionData.tq_answer == 'Yes'
    ) {
      return this.validateFindingsObj(formData, field);
    } else {
      if (!obj && errorSchema.properties) obj = errorSchema.properties[field];

      // clear any errors for CAPA and do it manually
      if (obj?.CAPA && formData[field]?.CAPA) delete obj.CAPA;
      // clear any errors for percentage_calculation and do it manually
      if (
        obj?.percentage_calculation &&
        formData[field]?.percentage_calculation
      )
        delete obj.percentage_calculation;

      if (
        selectedQuestionFormSchema?.no_checkbox_list?.hasOwnProperty(
          'readOnly'
        ) &&
        obj?.no_checkbox_list &&
        'No' !== formData[field]?.tq_answer
      ) {
        delete obj.no_checkbox_list;
      }
      if (
        this.props.formContext?.attributes?.evidenceSource ==
        'Transaction Testing'
      ) {
        cleanTransactions(obj);
      }

      const parentErrors = this.objectFlatten(obj);

      return (
        parentErrors.length === 0 &&
        this.validatePercentageCalculation(formData, field) &&
        this.validateCAPA(formData, field) &&
        this.validateCheckBoxes(
          cleanQuestionData,
          retrievedSchema,
          formData,
          field
        ) &&
        this.validateCitationResponse(formData, field) &&
        this.validateNarrativeResponse(formData, field) &&
        this.validateNotesResponse(
          this.props.formContext?.attributes?.evidenceSource,
          formData,
          field
        ) &&
        validateTransactions(
          this.props.formContext?.attributes?.evidenceSource,
          cleanQuestionData
        ).valid
      );
    }
  };

  validatePercentageCalculation = (formData, field) => {
    if (formData && formData[field] && formData[field].percentage_calculation) {
      if (
        formData[field].percentage_calculation.numerator &&
        formData[field].percentage_calculation.denominator &&
        formData[field].percentage_calculation.result &&
        formData[field].percentage_calculation.result != 'NAN'
      )
        return true;
      else return false;
    }
    return true;
  };

  validateCAPA = (formData, field) => {
    if (formData && formData[field] && formData[field].CAPA) {
      if (
        formData[field].CAPA.content_area &&
        formData[field].CAPA.performance_area
      )
        return true;
      else return false;
    }
    return true;
  };

  validateFindingsObj = (formData, field) => {
    let isFindingDataValidate = true;
    const findings = formData[field].findings;
    if (!Array.isArray(findings) || findings?.length === 0) {
      return false;
    }
    if (!findings) {
      isFindingDataValidate = false;
      return;
    } else {
      findings.forEach(findingData => {
        const ids = Object.keys(findingData);
        if (isEmpty(ids)) {
          isFindingDataValidate = false;
          return;
        } else {
          if (!findingData.CAPA) {
            isFindingDataValidate = false;
            return;
          }
          if (
            !findingData.CAPA.content_area &&
            !findingData.CAPA.performance_area
          ) {
            isFindingDataValidate = false;
          }
          if (!findingData?.hasOwnProperty('reason')) {
            isFindingDataValidate = false;
            return;
          }
          if (
            findingData?.hasOwnProperty('reason') &&
            isEmpty(findingData.reason)
          ) {
            isFindingDataValidate = false;
          }
          if (!isFindingDataValidate) {
            return;
          }
        }
      });
    }
    return isFindingDataValidate;
  };

  validateOther = questionData => {
    var results = true;
    if (!questionData) return results;
    var BreakException = {};
    try {
      Object.keys(questionData).forEach(key => {
        if (
          typeof questionData[key] === 'object' &&
          questionData[key] !== null
        ) {
          if (
            isArray(questionData[key]) &&
            questionData[key].includes(Constants.OTHER_KEY)
          ) {
            var otherReason = questionData[key].find(el =>
              el?.toString().startsWith(Constants.OTHER_REASON_KEY)
            );
            if (otherReason) {
              // Remove the prefix
              var textOnly = otherReason.replace(
                Constants.OTHER_REASON_KEY,
                ''
              );
              results = this.hasMeaningfulText(textOnly);
            } else {
              results = false;
            }
          } else {
            results = this.validateOther(questionData[key]);
          }
          if (!results) throw BreakException;
        }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    }
    return results;
  };

  validateCheckBoxes = (questionData, retrievedSchema, formData, field) => {
    const selectedQuestionFormSchema =
      retrievedSchema &&
      retrievedSchema.properties[field] &&
      retrievedSchema.properties[field].properties;
    let results = true;
    if (isEmpty(questionData) && !retrievedSchema) {
      return;
    }
    if (this.hasContingentCheckboxes(selectedQuestionFormSchema)) {
      for (const key in questionData) {
        if (
          typeof questionData[key] === 'object' &&
          questionData[key] !== null
        ) {
          if (Array.isArray(questionData[key])) {
            const filteredData = questionData[key].filter(
              item => !/^\d+_.*/.test(item)
            );
            if (!isEmpty(filteredData)) {
              for (const optionText of filteredData) {
                if (
                  this.checkContingentHasNoSubOptsSelected(
                    selectedQuestionFormSchema,
                    optionText,
                    key,
                    questionData[key]
                  )
                ) {
                  results = false;
                  return results;
                }
              }
            } else {
              results = false;
              return results;
            }

            if (questionData[key].includes(Constants.OTHER_KEY)) {
              const otherReason = questionData[key].find(el =>
                el?.toString().startsWith(Constants.OTHER_REASON_KEY)
              );
              if (!otherReason) {
                results = false;
                return results;
              }
            }
          }
        }
      }
      return results;
    } else {
      return this.validateOther(questionData);
    }
  };

  checkContingentHasNoSubOptsSelected = (
    selectedQuestionFormSchema,
    optionText,
    checkboxType,
    answeredCheckboxList
  ) => {
    if (checkboxType in selectedQuestionFormSchema) {
      const enumList = selectedQuestionFormSchema[checkboxType].items.enum;
      if (!enumList) return false;

      const index = enumList.indexOf(optionText);
      if (index !== -1) {
        const key = 'c' + index;
        const contingentItems =
          selectedQuestionFormSchema[checkboxType].contingentItems;
        const modifiedContingentItems = contingentItems[key]?.map(
          item => `${index}_${item}`
        );
        return (
          contingentItems.hasOwnProperty(key) &&
          contingentItems[key]?.length !== 0 &&
          !modifiedContingentItems.some(item =>
            answeredCheckboxList.includes(item)
          )
        );
      }
    }
    return false;
  };

  hasContingentCheckboxes = data => {
    if (!data) return false;
    const searchForContingent = obj => {
      for (const key in obj) {
        if (obj?.hasContingentCheckboxes === 1) {
          return true;
        }
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          if (searchForContingent(obj[key])) {
            return true;
          }
        }
      }
      return false;
    };

    return Object.values(data).some(searchForContingent);
  };

  hasItemStartingWithNumberUnderscore = data => {
    if (Array.isArray(data)) {
      return data.some(item => /^[0-9_]/.test(item));
    }
    return false;
  };

  objectFlatten = obj => {
    const result = [];
    for (const prop in obj) {
      const value = obj[prop];
      if (typeof value === 'object') {
        result.push(this.objectFlatten(value));
      } else {
        result.push(value);
      }
    }
    return _.flattenDeep(result);
  };

  removeAutoSaveFromEvidence = obj => {
    // Recursively search through the object
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        // Check if the property is 'evidence' and is an array
        if (key === 'evidence' && Array.isArray(obj[key])) {
          console.log(obj[key]);
          obj[key] = obj[key]
            .map(item => {
              if (!item) return item;
              let parts = item.split('|');
              if (parts[4] === 'autosave') {
                // Remove the last item 'autosave'
                parts.splice(4, 1);
              }
              // Join the parts back together and return the updated string
              return parts.join('|');
            })
            .filter(x => x !== null && x !== undefined);
        }

        // If the current property is an object, call the function recursively
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          this.removeAutoSaveFromEvidence(obj[key]);
        }
      }
    }
  };

  validateCitationResponse = (formData, field) => {
    if (formData?.[field]?.hasOwnProperty('citationResponse')) {
      if (this.hasMeaningfulText(formData[field].citationResponse)) return true;
      else return false;
    }
    return true;
  };

  validateNarrativeResponse = (formData, field) => {
    if (formData?.[field]?.hasOwnProperty('narrative')) {
      if (this.hasMeaningfulText(formData[field].narrative)) return true;
      else return false;
    }
    return true;
  };

  validateNotesResponse = (evidenceSource, formData, field) => {
    let isNotesComplete = true;
    if (
      'Center Exploration' == evidenceSource ||
      'Classroom Exploration' == evidenceSource
    ) {
      if (formData?.[field]?.hasOwnProperty('notes')) {
        if (this.hasMeaningfulText(formData[field].notes))
          isNotesComplete = true;
        else isNotesComplete = false;
      }
    }
    return isNotesComplete;
  };

  hasMeaningfulText = inputHTML => {
    const cleanHTML = DOMPurify.sanitize(inputHTML); // Sanitize to prevent XSS
    const plainText = cleanHTML
      .replace(/<[^>]*>/g, '') // Strip tags
      .replace(/&nbsp;/g, ' ') // Replace non-breaking spaces
      .trim();

    return plainText.length > 0;
  };
}
export default React.forwardRef(function EASFormWithRef(props, ref) {
  return <EASForm {...props} ref={ref} />;
});
